module.exports = __webpack_public_path__ + "img/facebook-icon.842f65e7.svg";